import type { ParticipantId } from "../types/common";
import type { ArchetypeConfig, InitialEntitySeed } from "../types/game-config";

export const DEFAULT_INITIAL_ENTITY_SEED: ReadonlyArray<InitialEntitySeed> = [
  // Participant 0 (bottom sector) — 7 stones in circular placement
  { id: "p0-stone-1", archetype: "STONE", ownerIndex: 0, x: 3.5, y: 1.5 },
  { id: "p0-stone-2", archetype: "STONE", ownerIndex: 0, x: 5.0, y: 1.5 },
  { id: "p0-stone-3", archetype: "STONE", ownerIndex: 0, x: 6.5, y: 1.5 },
  { id: "p0-stone-4", archetype: "STONE", ownerIndex: 0, x: 4.0, y: 2.5 },
  { id: "p0-stone-5", archetype: "STONE", ownerIndex: 0, x: 5.0, y: 2.5 },
  { id: "p0-stone-6", archetype: "STONE", ownerIndex: 0, x: 6.0, y: 2.5 },
  { id: "p0-stone-7", archetype: "STONE", ownerIndex: 0, x: 5.0, y: 3.5 },

  // Participant 1 (top sector) — 7 stones mirrored
  { id: "p1-stone-1", archetype: "STONE", ownerIndex: 1, x: 3.5, y: 8.5 },
  { id: "p1-stone-2", archetype: "STONE", ownerIndex: 1, x: 5.0, y: 8.5 },
  { id: "p1-stone-3", archetype: "STONE", ownerIndex: 1, x: 6.5, y: 8.5 },
  { id: "p1-stone-4", archetype: "STONE", ownerIndex: 1, x: 4.0, y: 7.5 },
  { id: "p1-stone-5", archetype: "STONE", ownerIndex: 1, x: 5.0, y: 7.5 },
  { id: "p1-stone-6", archetype: "STONE", ownerIndex: 1, x: 6.0, y: 7.5 },
  { id: "p1-stone-7", archetype: "STONE", ownerIndex: 1, x: 5.0, y: 6.5 },
];

function getArchetypeConfig(
  archetype: string,
  configs: ReadonlyArray<ArchetypeConfig>,
): ArchetypeConfig {
  const config = configs.find((item) => item.archetype === archetype);
  if (!config) {
    throw new Error(`No config found for archetype: ${archetype}`);
  }
  return config;
}

export function createInitialEntities(
  archetypes: ReadonlyArray<ArchetypeConfig>,
  participantIds: ReadonlyArray<ParticipantId> = ["P1", "P2"],
  seedEntities: ReadonlyArray<InitialEntitySeed> = DEFAULT_INITIAL_ENTITY_SEED,
) {
  return seedEntities.map((seed) => {
    const config = getArchetypeConfig(seed.archetype, archetypes);
    return {
      id: seed.id,
      archetype: seed.archetype,
      owner: participantIds[seed.ownerIndex],
      x: seed.x,
      y: seed.y,
      radius: config.radius,
      mass: config.mass,
      eliminated: false,
    };
  });
}
